

import {Vue, Component, Ref} from "vue-property-decorator";
import api from '@/api'
import {AuthenticateModel} from "@/api/appService";
import {ElForm} from "element-ui/types/form";

@Component({
  name: 'Login',
  components: {}
})
export default class Login extends Vue {

  loginForm :AuthenticateModel= {
    password: '',
    userNameOrEmailAddress: '',
    rememberClient: false
  };

  logging = false

  formRule = {
    password: [
      {required: true, message: '请输入密码'}
    ],
    userNameOrEmailAddress: [
      {required: true, message: '请输入用户名'}
    ]
  }


  login() {

    (this.$refs.loginForm as ElForm).validate().then((isValid) => {
      if (!isValid) {
        return
      }

      this.logging = true;

      api.tokenAuth.authenticate({body: this.loginForm}).then(response => {
        this.$store.commit('user/SET_TOKEN', response,{root:true});
        this.$store.dispatch('user/getUserInfo').then(() => {
          this.$router.push({path:'/selectStore'})
          // this.$router.push({path: '/dashboard'})
        })

      }).catch(() => {
        this.logging = false
      })

    })


  }

}
